import { render, staticRenderFns } from "./transfer-coins.vue?vue&type=template&id=16209260&scoped=true"
import script from "./transfer-coins.vue?vue&type=script&lang=js"
export * from "./transfer-coins.vue?vue&type=script&lang=js"
import style0 from "./transfer-coins.vue?vue&type=style&index=0&id=16209260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16209260",
  null
  
)

export default component.exports